"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _modal = _interopRequireDefault(require("./modal"));
exports["default"] = _modal["default"];